import { render, staticRenderFns } from "./WelfareCentreOperationEmployeesNumber.vue?vue&type=template&id=612fcae0&scoped=true&"
import script from "./WelfareCentreOperationEmployeesNumber.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreOperationEmployeesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612fcae0",
  null
  
)

export default component.exports